import React from 'react';
import { CenteredContentLayout } from '../../../components/containers/CenteredContentLayout';
import { Panel } from '../../../components/containers/Panel';
import { Button } from '../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { Link } from 'react-router-dom';
import { PanelHeader } from '../../../components/containers/Panel/PanelHeader.view';

export const ChromeExtensionView = (): JSX.Element => {
  return (
    <CenteredContentLayout headerTitle={'Chrome Extension'} hasSidebar={false}>
      <Panel>
        <PanelHeader title={'Share any page you’re reading, directly from your browser'} subTitle={''} />
        <div className={'padding-top-small-8 padding-bottom-small-8'}>
          Easily create posts from any webpage with our Chrome Extension—just click to share while you browse.
        </div>
        <ul className={'padding-top-small-12'}>
          <li>One-click sharing from any site</li>
          <li>Auto-fill link previews for easy scheduling</li>
          <li>Saves time by skipping copy-paste</li>
        </ul>
        <div className={'padding-bottom-small-12'}>
          <Button
            type={'button'}
            variant={'solid'}
            size={'medium'}
            color={ButtonColorsEnum.primary}
            action={() =>
              window.open('https://chrome.google.com/webstore/detail/smarterqueue/floofkpjijhgipeklkmpocopjjimfebm')
            }>
            Get Chrome Extension
          </Button>
        </div>
        <div className={'padding-top-small-12 padding-bottom-small-12'}>
          No Chrome? No problem! Copy the URL and paste it into the Post Editor on SmarterQueue.com.
        </div>
        <div className={'padding-top-small-8 padding-bottom-small-12'}>
          On mobile? Use our <Link to={'/settings/mobile'}>iOS & Android app</Link> to share content on the go.
        </div>
      </Panel>
    </CenteredContentLayout>
  );
};
